import { render, staticRenderFns } from "./yc-quota.vue?vue&type=template&id=a625f168&scoped=true&"
import script from "./yc-quota.vue?vue&type=script&lang=js&"
export * from "./yc-quota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a625f168",
  null
  
)

export default component.exports